import type { FC, SVGProps } from "react";

const IconNotAllowed: FC<SVGProps<SVGSVGElement>> = (props) => (
	<svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="currentColor" {...props}>
    <path d="M3.28589 3.28516L12.7132 12.7132" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M7.99992 14.6654C11.6818 14.6654 14.6666 11.6806 14.6666 7.9987C14.6666 4.3168 11.6818 1.33203 7.99992 1.33203C4.31802 1.33203 1.33325 4.3168 1.33325 7.9987C1.33325 11.6806 4.31802 14.6654 7.99992 14.6654Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
);

export default IconNotAllowed;
